"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.all = exports.Numerics = exports.Commands = void 0;
var tslib_1 = require("tslib");
var Commands = require("./Commands");
exports.Commands = Commands;
var Numerics = require("./Numerics");
exports.Numerics = Numerics;
exports.all = new Map(tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(Object.values(Commands))), tslib_1.__read(Object.values(Numerics))).map(function (cmd) { return [cmd.COMMAND, cmd]; }));
